import { IconButtonProps } from "../../types";
import { MyButton, IconImg } from "./Button.styles";

const IconButton: React.FC<IconButtonProps> = (props) => {
  const { icon, style, text, ...others } = props;
  return (
    <MyButton style={{ ...style }} {...others}>
      <div style={{ display: "flex" }}>
        <IconImg src={icon} alt="icon-btn" />
        <span>{text}</span>
      </div>
    </MyButton>
  );
};

export default IconButton;
